import {Component, ConfigOptions} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {TwoFactorOption, TwoFactorSelectionMenu} from 'common/widgets/two-factor-selection-menu';

import {template} from './template';
import './index.styl';

const MENU_SELECTOR = `.selection-menu`;

interface TwoFactorSelectionPageState {
  selection: TwoFactorOption;
}

export class TwoFactorSelectionPage extends Component<TwoFactorSelectionPageState> {
  static get attrsSchema() {
    return super.attrsSchema;
  }

  get config(): ConfigOptions<TwoFactorSelectionPageState> {
    return {
      template,
      defaultState: {
        selection: TwoFactorOption.NOT_SELECTED,
      },
      helpers: {
        MENU_SELECTOR,
        showTwoFactorSetUpScreen: (): void => {
          this.showScreenForOption();
        },
        showSelectionPage: (): void => {
          this.update({selection: TwoFactorOption.NOT_SELECTED});
        },
      },
    };
  }

  connectedCallback(): void {
    super.connectedCallback();
    mixpanel.track(`[2FA] Viewed Selection Page(FE)`);
  }

  private showScreenForOption(): void {
    const menuSelectorElement: TwoFactorSelectionMenu = this.querySelector(MENU_SELECTOR);
    this.update({selection: menuSelectorElement.state.highlightedTwoFactorOption});
  }
}

export const TwoFactorSelectionPageEl = defineAndMakeJsxFactory(`mp-two-factor-selection-page`, TwoFactorSelectionPage);
